module.exports = __webpack_public_path__ + "img/icon-fishing-yellow.d796d2cb.svg";